export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrowDownSmall.6aa2880f.svg","height":6,"width":10,"blurWidth":0,"blurHeight":0};